const tabMembershipBlocks = document.querySelectorAll('.block-tab-membership');

// Same key as gravity-forms/script.js
const TAB_MEMBERSHIP_SESSION_KEY = 'propel-tab-membership:last-intent';

const GF_TIER_TO_TYPE = {
	Gold: 'Gold',
	Family: 'Family',
	Gym: 'Gym Only',
	Daytime: 'Daytime',
	Passport: 'Passport',
};

const membershipTypeForGravityForm = (tierLabel, pricingRowLabel) => {
	const opt = (pricingRowLabel || '').trim();
	if (/young professional/i.test(opt)) {
		return 'Young Professional';
	}
	if (/college/i.test(opt)) {
		return 'College Student';
	}
	if (/passport/i.test(opt)) {
		return 'Passport';
	}
	const tier = (tierLabel || '').trim();
	return GF_TIER_TO_TYPE[tier] || tier;
};

if (tabMembershipBlocks.length > 0) {
	const toggleLocation = (
		e,
		locationIndex,
		locationButtons,
		locationContents,
		pricingTierButtons,
		pricingTierContents,
		selectedPricingTiers
	) => {
		const ariaControls = e.target.getAttribute('aria-controls');

		locationButtons?.forEach((button, i) => {
			const selected = locationIndex === i ? 'true' : 'false';
			button.setAttribute('aria-selected', selected);
		});

		locationContents?.forEach((content, i) => {
			if (locationIndex === i) {
				content.removeAttribute('hidden');
			} else {
				content.setAttribute('hidden', 'true');
			}
		});

		// Reset pricing tier to first option
		pricingTierButtons.forEach((button) => {
			const id = button.getAttribute('id');
			const selected =
				id === ariaControls + '-tiertab-0' ? 'true' : 'false';
			button.setAttribute('aria-selected', selected);
		});

		pricingTierContents.forEach((content) => {
			const id = content.getAttribute('id');
			if (id === ariaControls + '-tiercontent-0') {
				content.removeAttribute('hidden');
			} else {
				content.setAttribute('hidden', 'true');
			}
		});

		selectedPricingTiers?.forEach((tier) => {
			const firstButton = tier
				.closest('.block-tab-membership__pricing-tier-wrapper')
				?.querySelector('.block-tab-membership__pricing-tier-button');
			tier.innerText = firstButton.innerText;
		});
	};

	const togglePricingTier = (
		e,
		locationIndex,
		pricingTierButtons,
		pricingTierContents,
		selectedPricingTiers
	) => {
		const ariaControls = e.target.getAttribute('aria-controls');

		selectedPricingTiers?.forEach((tier, index) => {
			if (locationIndex === index) {
				tier.innerText = e.target.innerText;
			} else {
				const firstButton = tier
					.closest('.block-tab-membership__pricing-tier-wrapper')
					?.querySelector(
						'.block-tab-membership__pricing-tier-button'
					);

				tier.innerText = firstButton.innerText;
			}
		});

		pricingTierButtons?.forEach((button) => {
			const selected = e.target === button ? 'true' : 'false';
			button.setAttribute('aria-selected', selected);
		});

		pricingTierContents?.forEach((content) => {
			const id = content.getAttribute('id');

			if (id === ariaControls) {
				content.removeAttribute('hidden');
			} else {
				content.setAttribute('hidden', 'true');
			}
		});
	};

	tabMembershipBlocks.forEach((block) => {
		let locationIndex = 0;
		const locationButtons = block.querySelectorAll(
			'.block-tab-membership__location-buttons .wp-block-button__link'
		);
		const locationContents = block.querySelectorAll(
			'.block-tab-membership__content'
		);
		const pricingTierButtons = block.querySelectorAll(
			'.block-tab-membership__pricing-tier-button'
		);
		const pricingTierContents = block.querySelectorAll(
			'.block-tab-membership__pricing-tier-content'
		);
		const pricingTierWrappers = block.querySelectorAll(
			'.block-tab-membership__pricing-tier-wrapper'
		);
		const selectedPricingTiers = block.querySelectorAll(
			'.block-tab-membership__selected-pricing-tier'
		);

		const closeDropdown = () => {
			pricingTierWrappers?.forEach((wrapper) => {
				wrapper.classList.remove('open');
			});

			selectedPricingTiers?.forEach((tier) => {
				tier.setAttribute('aria-expanded', 'false');
			});
		};

		// Add click listener on location buttons
		locationButtons?.forEach((button, index) => {
			button.addEventListener('click', (e) => {
				locationIndex = index;

				toggleLocation(
					e,
					locationIndex,
					locationButtons,
					locationContents,
					pricingTierButtons,
					pricingTierContents,
					selectedPricingTiers
				);
			});
		});

		// Add click listener on pricing tier buttons
		pricingTierButtons?.forEach((button) => {
			button.addEventListener('click', (e) => {
				togglePricingTier(
					e,
					locationIndex,
					pricingTierButtons,
					pricingTierContents,
					selectedPricingTiers
				);
			});
		});

		// Add event listener on mobile to toggle pricing tiers dropdown
		selectedPricingTiers?.forEach((tier, index) => {
			tier.addEventListener('click', (e) => {
				const isOpen =
					pricingTierWrappers[index]?.classList.toggle('open');

				tier.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

				e.stopPropagation();
			});
		});

		if (block.id) {
			block.addEventListener('click', (e) => {
				const cta = e.target.closest(
					'.block-tab-membership__pricing-option a.wp-block-button__link'
				);
				if (!cta || !block.contains(cta)) {
					return;
				}

				const tierButton = block.querySelector(
					'.block-tab-membership__pricing-tier-button[aria-selected="true"]'
				);
				if (!tierButton) {
					return;
				}

				const locationButton = block.querySelector(
					'.block-tab-membership__location-buttons .wp-block-button__link[aria-selected="true"]'
				);
				const preferredLocation =
					locationButton?.textContent?.trim() || '';
				const tierLabel = tierButton.textContent?.trim() || '';
				const pricingOptionName =
					cta
						.closest('.block-tab-membership__pricing-option')
						?.querySelector(
							'.block-tab-membership__pricing-option-name'
						)
						?.textContent?.trim() || '';

				const membershipType = membershipTypeForGravityForm(
					tierLabel,
					pricingOptionName
				);

				try {
					sessionStorage.setItem(
						TAB_MEMBERSHIP_SESSION_KEY,
						JSON.stringify({
							membershipType,
							preferredLocation,
						})
					);
				} catch {
					// private mode / quota
				}
			});
		}

		document.body.addEventListener('click', closeDropdown);
	});
}
